import { useEffect, useState } from 'react';
import Link from './Link';
import { PARTICIPANT_SIGNUP_URL, SIGNUP_URL, isParticipantPage } from '../lib/links';

/* Per-route announcement copy, lifted from each page's original <div class="announce">. */
function Message({ pathname }: { pathname: string }) {
  // Participant pages pitch paid interviews, not the researcher offer.
  if (isParticipantPage(pathname)) {
    return (
      <span>
        Get paid for <b>15&ndash;30 minute voice interviews</b> &middot;{' '}
        <Link to={PARTICIPANT_SIGNUP_URL}>Become a participant</Link>
      </span>
    );
  }
  switch (pathname) {
    case '/interviews':
      return (
        <span>
          The first <b>3 interviews are free</b> &middot; the price includes recruitment &middot;{' '}
          <Link to={SIGNUP_URL}>Start free</Link> or <Link to="/pricing">see interview prices</Link>
        </span>
      );
    case '/swarm':
      return (
        <span>
          We always label <b>agent users</b> as agents &middot;{' '}
          <Link to={SIGNUP_URL}>Start free</Link> or <Link to="/pricing">see the prices</Link>
        </span>
      );
    case '/analysis':
      return (
        <span>
          Each claim in a study report links to <b>the clip that it comes from</b> &middot;{' '}
          <Link to={SIGNUP_URL}>Start free</Link> or <Link to="/pricing">see the prices</Link>
        </span>
      );
    case '/pricing':
      return (
        <span>
          The first <b>3 interviews are free</b> &middot; you do not need a card or a demo call &middot; <Link to={SIGNUP_URL}>Start free</Link>
        </span>
      );
    default:
      return (
        <span>
          The first <b>3 interviews are free</b> &middot;{' '}
          <Link to={SIGNUP_URL}>Start free</Link> or <Link to="/pricing">see the prices</Link>
        </span>
      );
  }
}

const DISMISS_KEY = 'ue-announce-dismissed';

export default function Announce({ pathname }: { pathname: string }) {
  const [dismissed, setDismissed] = useState(false);
  // Remember a close across page loads. Read after mount so the static HTML and hydration match.
  useEffect(() => {
    try {
      if (window.localStorage.getItem(DISMISS_KEY) === '1') setDismissed(true);
    } catch { /* storage blocked: the bar just shows again */ }
  }, []);
  function dismiss() {
    setDismissed(true);
    try { window.localStorage.setItem(DISMISS_KEY, '1'); } catch { /* storage blocked */ }
  }
  if (dismissed) return null;
  return (
    <div className="announce" id="announce">
      <div className="inner">
        <Message pathname={pathname} />
      </div>
      <button className="x" type="button" aria-label="Close the announcement" onClick={dismiss}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
